const BetaSignups = (state, action) => {
  switch (action.type) {
    case 'GET_ADMIN_BETA_SIGNUPS_SUCCESS':
      return { ...state, index: action.data }
    case 'CANCEL_ADMIN_BETA_SIGNUP_INVITE_SUCCESS':
    case 'SEND_ADMIN_BETA_SIGNUP_INVITE_SUCCESS':
      return {
        ...state,
        index: (state?.index || []).map((r) =>
          r.id === action.data?.id ? action.data : r
        ),
      }
    default:
      return state || {}
  }
}

export default BetaSignups
